export enum ManageStepperEnum {
  DA = "da",
  KSR = "ksr",
  PDR = "pdr",
  DA2 = "DA2"
}
